import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=2264a84d&scoped=true&lang=pug"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"
import style0 from "./Avatar.vue?vue&type=style&index=0&id=2264a84d&prod&lang=scss"
import style1 from "./Avatar.vue?vue&type=style&index=1&id=2264a84d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264a84d",
  null
  
)

export default component.exports